import React,{useState,useEffect} from "react";
import Main from '../../components/template/Main';
import useTable from "../../components/table/useTable";
import TableFooter from "../../components/table/TableFooter";
import { useHistory } from "react-router-dom";
import {get} from '../../store/config/register';
import { login_Id } from "../../store/config/dadosuser";
import { format,parse } from "date-fns";

const headerProps = {
  icon: 'envelope-o',
  title: 'Ocorrência'
}

export default function Ocorrencia (){

  const [ocorrencias,setOcorrencias] = useState([]);
  const [page, setPage] = useState(1);
  const { slice, range } = useTable(ocorrencias, page, 10);
  const history = useHistory();

  useEffect(() =>{
    buscaOcorrencia();
  },[])

  async function buscaOcorrencia(){
    const ocor = await get('/Ocorrencia/v1/Login/'+ login_Id);

    if(ocor !== undefined){
      setOcorrencias(ocor);
    }
  }  
  
  function renderTable() {
        return (
         
          <div className="aviso">
             {slice === undefined ? null : slice.map((ocorrencia) => {
                return (
                  <div className="mensagem" onClick={()=> true}>
                    <ul className="cont">
                      <li>Data do envio: &nbsp; {ocorrencia.data === '' ? '' : format(parse(ocorrencia.data,"yyyy-MM-dd'T'HH:mm:ss",new Date()),'dd/MM/yyyy')}</li>
                      <li>Assunto:  {ocorrencia.titulo}</li>
                    </ul>
                  </div>
                );
    
             })  
             }
             <div className="tabelaAviso">
              <TableFooter range={range} slice={slice} setPage={setPage} page={page} />
             </div>
          </div>
          
        );
      }

    function renderForm(){

        return (
            <div className="btnNovo">
              <button className="btn btn-primary" onClick={()=> history.push('/Ocorrencia/Cadastro')}>Novo</button>
              <button className="btn btn-info" onClick={()=> history.push('/Ocorrencia/Responsavel')}>Ocorrências</button>
              <hr />
                {renderTable()}
            </div>
        );
    }
return (
    <Main {...headerProps}>
        {renderForm()}
    </Main>
);
}